(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DESKTOP_MQ = window.matchMedia('(min-width: 990px)');

    document.querySelectorAll('.mh__drawer .mh__scrim').forEach(function (scrim) {
      scrim.addEventListener('click', function () {
        var drawer = scrim.closest('.mh__drawer');
        if (drawer) drawer.open = false;
      });
    });

    document.querySelectorAll('.mh__item--mega .mh__details').forEach(function (details) {
      var summary = details.querySelector('summary');

      function openMenu() {
        if (!DESKTOP_MQ.matches) return;
        details.classList.add('is-open');
        details.setAttribute('open', '');
      }

      function closeMenu() {
        if (!DESKTOP_MQ.matches) return;
        details.classList.remove('is-open');
        details.removeAttribute('open');
      }

      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', closeMenu);
      details.addEventListener('focusin', openMenu);
      details.addEventListener('focusout', function (event) {
        if (!DESKTOP_MQ.matches) return;
        if (details.contains(event.relatedTarget)) return;
        closeMenu();
      });

      if (summary) {
        summary.addEventListener('click', function (event) {
          if (DESKTOP_MQ.matches) event.preventDefault();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
